var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.myPageLocator)?_c('v-runtime-template',{attrs:{"template":"<div slot=default style ='text-align: -webkit-center'>" + _vm.myPageLocator + '</div>'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }